// A draft is provisional; the authoritative final response replaces it exactly once.
export const updateHermesDraft = (messages, type, data) => {
  if (!data.run_id || typeof data.text !== 'string') return messages;
  const index = messages.findIndex((item) => item.streaming && item.runId === data.run_id);
  const draft = {
    role: 'assistant', agent: 'hermes', streaming: true, runId: data.run_id,
    content: (type === 'message_delta' && index >= 0 ? messages[index].content : '') + data.text,
  };
  return index < 0 ? [...messages, draft] : messages.map((item, i) => i === index ? draft : item);
};

export const clearHermesDraft = (messages) => messages.filter((item) => !item.streaming);

// La réponse à une carte d'accord est arrivée (action faite, refusée ou trop tard) : la carte ne reste pas sur
// « Action en cours… » (2026-11-03).
export const settleConfirmations = (messages) => messages.map((item) => (
  item.type === 'confirmation' && item.confirmation?.locked
    ? { ...item, confirmation: { ...item.confirmation, locked: false, answered: true } } : item));
